/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_Company_NameInputs */

const en_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand / Company Name`)
};

const es_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la Marca / Empresa`)
};

const fr_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de la Marque / Entreprise`)
};

const de_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marken- / Firmenname`)
};

const ja_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブランド / 会社名`)
};

const zh_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品牌 / 公司名称`)
};

const ar_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم العلامة التجارية / الشركة`)
};

const id_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Merek / Perusahaan`)
};

const it_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del Brand / Azienda`)
};

const ru_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название Бренда / Компании`)
};

const pt_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da Marca / Empresa`)
};

const ko_brand_company_name = /** @type {(inputs: Brand_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브랜드 / 회사명`)
};

/**
* | output |
* | --- |
* | "Brand / Company Name" |
*
* @param {Brand_Company_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const brand_company_name = /** @type {((inputs?: Brand_Company_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_Company_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_brand_company_name(inputs)
	if (locale === "es") return es_brand_company_name(inputs)
	if (locale === "fr") return fr_brand_company_name(inputs)
	if (locale === "de") return de_brand_company_name(inputs)
	if (locale === "ja") return ja_brand_company_name(inputs)
	if (locale === "zh") return zh_brand_company_name(inputs)
	if (locale === "ar") return ar_brand_company_name(inputs)
	if (locale === "id") return id_brand_company_name(inputs)
	if (locale === "it") return it_brand_company_name(inputs)
	if (locale === "ru") return ru_brand_company_name(inputs)
	if (locale === "pt") return pt_brand_company_name(inputs)
	return ko_brand_company_name(inputs)
});